import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

/**
 * Qual home o usuário escolheu ver em `/admin/index`.
 *
 * A escolha vive no `localStorage` do navegador: é preferência de tela, não
 * dado de negócio, e a v2 deve virar padrão de todo mundo em pouco tempo.
 * Consequência conhecida e aceita: quem escolher no computador escolhe de novo
 * no celular, e limpar o cache do navegador volta para a home antiga.
 */
@Injectable({providedIn: 'root'})
export class PreferenciaHomeService {
  private static readonly CHAVE = 'promokit.home.v2';

  private readonly escolha = new BehaviorSubject<boolean>(PreferenciaHomeService.leia());

  /** Emite a cada troca para quem estiver mostrando a home no momento. */
  get mudou(): Observable<boolean> {
    return this.escolha.asObservable();
  }

  get usaHomeNova(): boolean {
    return this.escolha.value;
  }

  escolhaHomeNova() {
    this.guarde(true);
  }

  volteParaHomeAnterior() {
    this.guarde(false);
  }

  private guarde(nova: boolean) {
    try {
      if (nova) localStorage.setItem(PreferenciaHomeService.CHAVE, '1');
      else localStorage.removeItem(PreferenciaHomeService.CHAVE);
    } catch (erro) {
      // Navegador com armazenamento bloqueado: a escolha vale só nesta sessão.
    }

    this.escolha.next(nova);
  }

  private static leia(): boolean {
    try {
      return localStorage.getItem(PreferenciaHomeService.CHAVE) === '1';
    } catch (erro) {
      return false;
    }
  }
}
